import { render, staticRenderFns } from "./TableSupervisionFlagHandler.vue?vue&type=template&id=1ac85464&scoped=true"
import script from "./TableSupervisionFlagHandler.vue?vue&type=script&lang=js"
export * from "./TableSupervisionFlagHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac85464",
  null
  
)

export default component.exports